<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <v-autocomplete
                ref="input"
                v-model="inputValue"
                v-test-id
                class="edit__selection__input"
                :name="name || uuid"
                :outlined="outlined"
                dense
                :rules="validators"
                :label="hideLabel ? null : label"
                :hint="hint"
                :description="description"
                :placeholder="hidePlaceholder ? null : placeholder"
                background-color="background"
                color="primaryText"
                item-color="primaryText"
                :hide-details="hideDetails || !form"
                :disabled="disabled"
                :loading="loading"
                :readonly="readonly"
                :items="items"
                :required="required"
                :append-icon="getIcon('dropdown', 'far')"
                :clear-icon="getIcon('clear', 'far')"
                :autocomplete="autocomplete ? 'on' : 'off'"
                :error="error"
                :error-messages="errorMessages"
                :single-line="singleLine"
                :rounded="rounded"
                :multiple="multiple"
                @focus="$emit('focus', inputValue)"
                @blur="$emit('blur', inputValue)"
                @keyup="$emit('keyup', inputValue)"
                @keydown="$emit('keydown', inputValue)"
                @click="$emit('click', inputValue)"
                @change="$emit('change', inputValue)"
            >
                <template v-if="findSlot('selection')" #selection="attrs">
                    <slot name="selection" v-bind="attrs" />
                </template>

                <template v-if="findSlot('item')" #item="attrs">
                    <slot name="item" v-bind="attrs" />
                </template>

                <template #append>
                    <slot name="append" />
                    <app-button
                        v-if="clearable && !readonly && !disabled && !required && inputValue !== null"
                        :icon="getIcon('clear', 'far')"
                        class="ml-2 align-self-center"
                        small
                        icon-size="1.4em"
                        @click="inputValue = null"
                    />
                </template>

                <template #append-outer>
                    <slot name="append-outer" />
                </template>
            </v-autocomplete>
        </div>
    </transition>
</template>

<script>
import Edit from './Edit';

export default {
    name: 'EditSelection',
    extends: Edit,
    props: {
        items: {
            type: Array,
            default: () => []
        },
        multiple: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
.edit__selection {
    min-width: 7rem;
}
</style>
